import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor(private toastr: ToastrService) { }

  public onSuccess(title: string, body: string) {
    this.toastr.success(body, title, {
      progressBar: true,
      closeButton: true,
      positionClass: 'toast-bottom-right',
      timeOut: 3500,
      easeTime: 350,
    })
  }

  // public onFailure(title: string, body: string) {
  //   this.toastr.error(body, title, {
  //     progressBar: true,
  //     closeButton: true,
  //     positionClass: 'toast-bottom-right',
  //     timeOut: 3500,
  //     easeTime: 350,
  //   })
  // }
  public onFailure(title: string, body: string) {
    this.toastr.error(body, title, {
      progressBar: true,
      closeButton: true,
      positionClass: 'toast-bottom-right',
      timeOut: 3500,
      easeTime: 350,
    });
  }

  onInfo(title: string, body: string): void {
    this.toastr.info(body, title, {
      progressBar: true,
      closeButton: true,
      positionClass: 'toast-bottom-right',
      timeOut: 3500,
      easeTime: 350,
    })
  }
}
